import React from "react";
import { DialogContent, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { enqueueSnackbar } from "notistack";
import useManufacturerUpdate from "src/hooks/manufacturer/useManufacturerUpdate";
import useAppGlobal from "src/context/useAppGlobal";
import useManufacturerCreate from "src/hooks/manufacturer/useManufacturerCreate";
import ReactHookFields from "src/components/shared/ReactHookForm";
import useManufacturerSchema from "./utils/useManufacturerSchema";

export default function ManufactureCreate({ item }) {
  const { closeDialog } = useAppGlobal();
  const { manuObject, manufacturerFieldList, validationSchema } = useManufacturerSchema({
    item,
  });
  const { trigger: createManufacturer } = useManufacturerCreate();
  const { trigger: updateManufacturer } = useManufacturerUpdate(item?._id);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: manuObject,
    shouldUnregister: false,
  });

  const handleCreateManu = async (data) => {
    let res;
    if (!item) {
      res = await createManufacturer({
        body: data,
      });
    } else {
      res = await updateManufacturer({
        body: data,
      });
    }
    if (!res?.success) {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    } else {
      reset();
      closeDialog();
      enqueueSnackbar("Thành công!", { variant: "success" });
    }
  };

  return (
    <DialogContent>
      <Stack py={2}>
        <ReactHookFields
          onSubmit={handleSubmit(handleCreateManu)}
          listFields={manufacturerFieldList}
          control={control}
          errors={errors}
          btnFullWidth={true}
        />
      </Stack>
    </DialogContent>
  );
}
